import dateFormat from 'dateformat';

const DateUtility =
{
    format(date: Date | string | undefined, format: string | undefined = 'dd.mm.yyyy.') {
        if (!date)
            return '';

        return dateFormat(date, format)
    },

    formatWithTime(date: Date | undefined, format: string | undefined = 'dd.mm.yyyy. HH:MM:ss') {
        if (!date)
            return '';

        return dateFormat(date, format)
    },

    toString(value: any) {
        return value ? new Date(value).toLocaleDateString('hr').replace(/\s+/g, '') : '';
    },
}

export default DateUtility;